export default __webpack_public_path__ + "static/media/hoop.70eae28f.webp";